import React from 'react'
import * as Primitive from '@radix-ui/react-scroll-area'
import { FloraVariants, forwardRef } from '@grupoboticario/flora-react-system'
import {
  StyledCorner,
  StyledScrollArea,
  StyledThumb,
  StyledScrollbar,
  StyledViewport,
} from './ScrollAreaComponents'
import { HTMLFloraProps } from '@grupoboticario/flora-react-utils'

type ScrollBarProps = Primitive.ScrollAreaScrollbarProps &
  FloraVariants<typeof StyledScrollbar> &
  FloraVariants<typeof StyledThumb>

export type ScrollAreaProps = HTMLFloraProps<'div'> & Primitive.ScrollAreaProps & ScrollBarProps

/**
 * @component
 * @name ScrollArea
 * @description ScrollArea component
 * @tutorial https://flora.gb.tech/docs/components/core/scroll-area
 */
export const ScrollArea = forwardRef<'div', ScrollAreaProps>((props, forwardedRef) => {
  const {
    children,
    css,
    dir = 'ltr',
    type = 'auto',
    variant,
    orientation = 'vertical',
    ...rest
  } = props

  return (
    <StyledScrollArea data-flora="scroll-area" css={css} dir={dir} type={type} {...rest}>
      <StyledViewport data-flora="scroll-viewport" ref={forwardedRef}>
        {children}
      </StyledViewport>
      <ScrollBar orientation={orientation} variant={variant} />
      <StyledCorner />
    </StyledScrollArea>
  )
})

const ScrollBar = (props: ScrollBarProps) => {
  return (
    <>
      <StyledScrollbar {...props}>
        <StyledThumb variant={props.variant} />
      </StyledScrollbar>
    </>
  )
}
